import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pause_solid",
  "use": "pause_solid-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"pause_solid\"><path d=\"M9.1 5H6.8c-1 0-1.9.8-1.9 1.9v10.3c0 1 .8 1.9 1.9 1.9h2.3c1 0 1.9-.8 1.9-1.9V6.9C11 5.8 10.2 5 9.1 5m8 0h-2.3c-1 0-1.9.8-1.9 1.9v10.3c0 1 .8 1.9 1.9 1.9h2.3c1 0 1.9-.8 1.9-1.9V6.9c0-1.1-.8-1.9-1.9-1.9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol